import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../../../services/Auth/auth.service';
import { BookingCardComponent } from "../../../booking-card/booking-card.component";

@Component({
    selector: 'app-upcoming',
    imports: [
        CommonModule,
        BookingCardComponent
    ],
    templateUrl: './upcoming.component.html',
    styleUrl: './upcoming.component.scss'
})
export class UpcomingComponent {

    constructor(
        public authService: AuthService
    ) {

    }
}
